/* istanbul ignore file */
import { fireLinkTag } from './tagManager';

export function tagShopMoreLinkClick() {
  fireLinkTag(
    {
      event_name: 'pdp sales link click',
      link_name: 'pdp sales link click',
    },
    true,
  );
}

export default {
  tagShopMoreLinkClick,
};
